import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #FFFFFF;
    margin:14px;
`;

export default StyledLink;